import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const citizenServicesCategoryField =`
id
detailsUniqueId
serviceIsAutomated
serviceAutomatedPart
serviceProvisions {
  id
  provisionUniqueId
  serviceProvisionMeans
  serviceSystemName
  serviceReachLink
}
serviceExistenceSources {
  id
  existenceUniqueId
  serviceExistenceSource
  serviceExistenceSourceLink
}
`;



export const GET_CITIZEN_SERVICES_AUTOMATION_DETAILS = gql`
query CitizenGetServicesAutomationDetails($filtering:ServiceAutomationFilterInputObject){
    citizenGetServicesAutomationDetails(filtering: $filtering){
    ${baseResponseGraphqlField}
    data {
      ${citizenServicesCategoryField}
    }
  }
}
`
;
